{
  "until": "{{duration}} deri në {{prayer}}",
  "begin_focus": "Nis fokusin",
  "add_task": "Shto detyrë",
  "more_tasks": "+{{count}} të tjera",
  "fajr_at": "Fajr në {{time}}",
  "schedule_title": "Sot",
  "plan_my_day": "Planifiko ditën time",
  "planning": "Duke planifikuar…",
  "suggested": "E sugjeruar",
  "keep_plan": "Mbaj planin",
  "undo_plan": "Zhbëj",
  "plan_error": "Nuk u planifikua dot tani. Provo sërish.",
  "plan_empty": "S'ka ende asgjë për të planifikuar — shto një detyrë së pari.",
  "plan_settled": "Gjithçka është tashmë në vendin e vet.",
  "view_list": "Lista",
  "view_switch_aria": "Kalo mes pamjes listë dhe asaj të ditës",
  "unassigned": "Të paplanifikuara",
  "assign_title": "Blloku i namazit",
  "no_block": "Pa bllok",
  "assign_aria": "Cakto në një bllok namazi",
  "open_schedule_aria": "Hap orarin e sotëm",
  "focus_session_label": "{{block}} · Fokus",
  "block_hero": "Punë e thellë deri në {{prayer}}",
  "moments_away": "{{prayer}} është fare afër",
  "block_clear": "Gjithçka gati — pusho deri në {{prayer}}",
  "alhamdulillah": "Elhamdulilah",
  "exit_hint": "Esc për të dalë qetësisht",
  "exit_hint_touch": "Prek ✕ për të dalë qetësisht",
  "mark_done_aria": "Shëno detyrën si të kryer",
  "quick_add_placeholder": "Shto në këtë bllok…",
  "focus_task_aria": "Fokusohu te kjo detyrë"
}
